/* Follicures theme. No libraries. All prices are rendered by Liquid; nothing is calculated here. */
(() => {
  'use strict';

  const CART_SECTION = 'cart-drawer';
  const $$ = (selector, root = document) => Array.from(root.querySelectorAll(selector));

  /* Cart */

  const drawer = () => document.querySelector('[data-cart-drawer]');

  function openCart() {
    const el = drawer();
    if (el && !el.open) el.showModal();
  }

  function closeCart() {
    const el = drawer();
    if (el && el.open) el.close();
  }

  function renderCart(html) {
    const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-contents]');
    if (!fresh) return;
    $$('[data-cart-contents]').forEach((el) => {
      el.innerHTML = fresh.innerHTML;
      el.dataset.itemCount = fresh.dataset.itemCount;
    });
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = fresh.dataset.itemCount;
      el.hidden = fresh.dataset.itemCount === '0';
    });
  }

  async function postCartForm(form, submitter) {
    const body = new URLSearchParams(new FormData(form));
    if (submitter && submitter.name) body.set(submitter.name, submitter.value);
    body.set('sections', CART_SECTION);
    body.set('sections_url', window.location.pathname);

    const response = await fetch(`${form.getAttribute('action')}.js`, {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/x-www-form-urlencoded' },
      body
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message);
    return data;
  }

  /* Liquid prints this form only when the cart could be cheaper with other real packs,
     for example a single bottle added on top of a 2-pack. Submitting it merges them. */

  async function settleCart(html) {
    const form = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-settle]');
    if (!form) return html;
    const data = await postCartForm(form);
    return (data.sections && data.sections[CART_SECTION]) || html;
  }

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!form.matches('[data-cart-form]')) return;
    event.preventDefault();

    const root = form.closest('[data-product-root]');
    const error = root ? root.querySelector('[data-form-error]') : null;
    const buttons = form.id ? $$(`button[form="${form.id}"]`) : $$('button', form);
    buttons.forEach((button) => button.setAttribute('aria-busy', 'true'));
    if (error) error.hidden = true;

    try {
      const data = await postCartForm(form, event.submitter);
      if (data.sections && data.sections[CART_SECTION]) renderCart(await settleCart(data.sections[CART_SECTION]));
      if (form.dataset.cartForm === 'add') openCart();
    } catch (err) {
      if (err instanceof TypeError) {
        form.submit();
      } else if (error) {
        error.textContent = err.message;
        error.hidden = false;
      }
    } finally {
      buttons.forEach((button) => button.removeAttribute('aria-busy'));
    }
  });

  document.addEventListener('click', (event) => {
    const open = event.target.closest('[data-cart-open]');
    if (open && drawer()) {
      event.preventDefault();
      openCart();
      return;
    }
    if (event.target.closest('[data-cart-close]') || event.target === drawer()) closeCart();
  });

  /* Same-page links scroll without changing the URL: the Meta pixel counts a hash
     change as a new PageView. Without JS they still work as plain anchors. */

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href^="#"]');
    const target = link && document.getElementById(link.getAttribute('href').slice(1));
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView();
    if (target.hasAttribute('tabindex')) target.focus({ preventScroll: true });
  });

  /* Pack selector. Never change the URL here, for the same reason: each pack click
     would add a false PageView. */

  function applyPack(input, moveGallery) {
    const root = input.closest('[data-product-root]');
    if (!root) return;
    const pack = input.dataset;

    $$('[data-price]', root).forEach((el) => { el.textContent = pack.packPrice; });
    $$('[data-compare]', root).forEach((el) => {
      el.textContent = pack.packCompare || '';
      el.hidden = !pack.packCompare;
    });
    $$('[data-save]', root).forEach((el) => {
      el.textContent = pack.packSave || '';
      el.hidden = !pack.packSave;
    });
    $$('[data-pack-label]', root).forEach((el) => { el.textContent = pack.packLabel; });
    $$('[data-pack-choice]', root).forEach((el) => {
      el.setAttribute('aria-pressed', String(el.dataset.packChoice === input.value));
    });

    const available = pack.packAvailable === 'true';
    $$('[data-buy-button]', root).forEach((button) => {
      button.disabled = !available;
      const label = button.querySelector('[data-buy-label]');
      if (label) label.textContent = available ? button.dataset.labelAdd : button.dataset.labelSoldout;
    });

    if (moveGallery && pack.packMedia) {
      const gallery = root.querySelector('[data-gallery]');
      if (gallery && gallery.goToMedia) gallery.goToMedia(pack.packMedia);
    }
  }

  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-pack]')) applyPack(event.target, true);
  });

  /* Gallery */

  function initGallery(gallery) {
    const track = gallery.querySelector('[data-gallery-track]');
    if (!track) return;
    const slides = $$('[data-media-id]', track);
    const dots = $$('[data-dot]', gallery);
    const thumbs = $$('[data-thumb]', gallery);

    const setActive = (index) => {
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
      thumbs.forEach((thumb, i) => thumb.setAttribute('aria-current', String(i === index)));
    };
    const revealMedia = () => {
      $$('template[data-defer-media]', gallery).forEach((template) => {
        template.replaceWith(template.content.cloneNode(true));
      });
    };
    if (document.readyState === 'complete') {
      revealMedia();
    } else {
      window.addEventListener('load', revealMedia, { once: true });
    }
    track.addEventListener('scroll', revealMedia, { once: true, passive: true });

    const goTo = (index) => {
      revealMedia();
      const slide = slides[index];
      if (slide) track.scrollTo({ left: slide.offsetLeft - slides[0].offsetLeft, behavior: 'smooth' });
    };

    let ticking = false;
    track.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(() => {
        ticking = false;
        const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
        let nearest = 0;
        slides.forEach((slide, i) => {
          const offset = (el) => Math.abs(el.offsetLeft - slides[0].offsetLeft - track.scrollLeft);
          if (offset(slide) < offset(slides[nearest])) nearest = i;
        });
        setActive(atEnd ? slides.length - 1 : nearest);
      });
    }, { passive: true });

    thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => goTo(i)));
    gallery.goToMedia = (mediaId) => {
      const index = slides.findIndex((slide) => slide.dataset.mediaId === mediaId);
      if (index >= 0) goTo(index);
    };
  }

  /* Sticky buy bar */

  function initSticky(root) {
    const bar = root.querySelector('[data-sticky-buy]');
    const anchor = root.querySelector('[data-buy-anchor]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(([entry]) => {
      bar.hidden = entry.isIntersecting;
      if (entry.isIntersecting) {
        const picker = bar.querySelector('[data-sticky-pack]');
        if (picker) picker.removeAttribute('open');
      }
    }).observe(anchor);
  }

  /* Scroll helpers */

  const scrollers = new Set();
  let scrollQueued = false;
  const queueScrollers = () => {
    if (scrollQueued) return;
    scrollQueued = true;
    window.requestAnimationFrame(() => {
      scrollQueued = false;
      scrollers.forEach((run) => run());
    });
  };
  window.addEventListener('scroll', queueScrollers, { passive: true });
  window.addEventListener('resize', queueScrollers);

  const clamp = (value, min, max) => Math.min(Math.max(value, min), max);
  const staysStill = () => (window.Shopify && window.Shopify.designMode)
    || !('IntersectionObserver' in window)
    || window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Oil drop: falls as the customer scrolls down and rises as they scroll back up.
     It eases towards its target and stretches with speed, so it moves like liquid. */

  function initDrop(stage) {
    if (staysStill()) return;
    const drop = stage.querySelector('[data-drop]');
    const thread = stage.querySelector('[data-drop-thread]');
    const items = $$('.drop-benefit', stage);
    if (!drop) return;
    stage.classList.add('is-armed');

    let current = 0;
    let target = 0;
    let stretch = 1;
    let running = false;
    let travel = 0;
    let dropHeight = 0;
    let reveals = [];

    const measure = () => {
      dropHeight = drop.offsetHeight;
      // Each dot sits at the top of its benefit. A benefit and its dot only appear once
      // the tip of the drop has passed, and the drop always ends clear of the last dot.
      const dots = items.map((item) => item.offsetTop + 17);
      reveals = dots.map((dot) => dot + 2);
      travel = Math.max(stage.offsetHeight - dropHeight, Math.max(0, ...dots) + 14);
    };

    const frame = () => {
      const gap = target - current;
      current += gap * 0.16;
      if (Math.abs(gap) < 0.3) current = target;
      const wanted = 1 + Math.min(Math.abs(gap) * 0.0045, 0.16);
      stretch += (wanted - stretch) * 0.25;
      drop.style.transform = `translate3d(0, ${current.toFixed(1)}px, 0) scale(${(1 / Math.sqrt(stretch)).toFixed(3)}, ${stretch.toFixed(3)})`;
      if (thread) thread.style.transform = `scaleY(${(current + dropHeight * 0.1).toFixed(1)})`;
      items.forEach((item, i) => item.classList.toggle('is-out', current >= reveals[i]));
      if (current !== target || Math.abs(stretch - 1) > 0.002) {
        window.requestAnimationFrame(frame);
      } else {
        running = false;
      }
    };

    const update = () => {
      // Moves from the moment it enters the screen: it slides while rising into view, then
      // holds its height on screen just above the sticky bar, going down with the customer.
      const scrolled = window.innerHeight - stage.getBoundingClientRect().top;
      target = clamp(Math.max(scrolled * 0.35, scrolled - dropHeight - 84), 0, travel);
      if (!running) {
        running = true;
        window.requestAnimationFrame(frame);
      }
    };

    measure();
    if ('ResizeObserver' in window) {
      new ResizeObserver(() => { measure(); queueScrollers(); }).observe(stage);
    }
    scrollers.add(update);
    update();
  }

  /* Sticky bar: change the pack without scrolling back up. The rows are built from the
     pack cards on the page, so they always show the same real prices. */

  function initStickyPack(root) {
    const options = root.querySelector('[data-sticky-pack-options]');
    if (!options) return;
    const rows = $$('[data-pack]', root).map((input) => {
      const card = input.closest('.bundle');
      const text = (selector) => {
        const el = card.querySelector(selector);
        return el ? el.textContent.trim() : '';
      };
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'sticky-pack__option';
      button.disabled = input.disabled;
      button.dataset.packChoice = input.value;
      button.setAttribute('aria-pressed', String(input.checked));

      const name = document.createElement('span');
      name.className = 'sticky-pack__name';
      name.textContent = text('.bundle__name');
      if (text('.bundle__badge')) {
        const badge = document.createElement('span');
        badge.className = 'sticky-pack__badge';
        badge.textContent = text('.bundle__badge');
        name.append(badge);
      }
      const price = document.createElement('span');
      price.className = 'sticky-pack__price';
      price.textContent = text('.bundle__price');
      const meta = document.createElement('span');
      meta.className = 'sticky-pack__meta';
      meta.textContent = text('.bundle__each');
      if (text('.bundle__save')) {
        const save = document.createElement('span');
        save.className = 'sticky-pack__save';
        save.textContent = ` · ${text('.bundle__save')}`;
        meta.append(save);
      }
      if (card.querySelector('.bundle__ship')) {
        const free = document.createElement('span');
        free.className = 'sticky-pack__free';
        free.textContent = ` · ${options.dataset.freeLabel}`;
        meta.append(free);
      }
      button.append(name, price, meta);
      return button;
    });
    options.replaceChildren(...rows);
  }

  document.addEventListener('click', (event) => {
    const choice = event.target.closest('[data-pack-choice]');
    if (!choice) return;
    const root = choice.closest('[data-product-root]');
    const input = root.querySelector(`[data-pack][value="${CSS.escape(choice.dataset.packChoice)}"]`);
    if (input && !input.disabled) input.click();
    const picker = choice.closest('[data-sticky-pack]');
    if (picker) picker.removeAttribute('open');
  });

  /* A link to any page with the pack selector can carry ?variant= */

  function selectPackFromUrl() {
    const id = new URLSearchParams(window.location.search).get('variant');
    if (!id) return;
    const input = document.querySelector(`[data-pack][value="${CSS.escape(id)}"]:not([disabled])`);
    if (input) input.checked = true;
  }

  /* Announcement bar: rotates only when there is more than one message */

  function initAnnouncement(bar) {
    const items = $$('[data-announcement-item]', bar);
    if (items.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    let current = 0;
    window.setInterval(() => {
      if (bar.closest('.shopify-section') && document.hidden) return;
      items[current].hidden = true;
      current = (current + 1) % items.length;
      items[current].hidden = false;
    }, 5000);
  }

  /* Video: the player only loads after a tap */

  document.addEventListener('click', (event) => {
    const play = event.target.closest('[data-video-play]');
    if (!play) return;
    const frame = play.closest('[data-video]');
    const template = frame.querySelector('template');
    frame.replaceChildren(template.content.cloneNode(true));
    const video = frame.querySelector('video');
    if (video) video.play();
  });

  /* Mobile nav and sticky pack picker: close on Escape or a tap outside */

  const POPUPS = '[data-nav-mobile][open], [data-sticky-pack][open]';
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') $$(POPUPS).forEach((popup) => popup.removeAttribute('open'));
  });
  document.addEventListener('click', (event) => {
    $$(POPUPS).forEach((popup) => {
      if (!popup.contains(event.target)) popup.removeAttribute('open');
    });
  });

  /* Setup, including sections re-rendered by the theme editor */

  function init(scope) {
    $$('[data-gallery]', scope).forEach(initGallery);
    $$('[data-product-root]', scope).forEach(initSticky);
    $$('[data-announcement]', scope).forEach(initAnnouncement);
    $$('[data-drop-stage]', scope).forEach(initDrop);
    $$('[data-product-root]', scope).forEach(initStickyPack);
    $$('[data-pack]:checked', scope).forEach((input) => applyPack(input, false));
  }

  selectPackFromUrl();
  init(document);

  // A cart saved before this page loaded may still need merging.
  const savedCart = document.querySelector('[data-cart-settle]');
  if (savedCart) {
    postCartForm(savedCart)
      .then((data) => { if (data.sections && data.sections[CART_SECTION]) renderCart(data.sections[CART_SECTION]); })
      .catch(() => {});
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:select', (event) => {
    if (event.target.querySelector('[data-cart-drawer]')) openCart();
  });
  document.addEventListener('shopify:section:deselect', (event) => {
    if (event.target.querySelector('[data-cart-drawer]')) closeCart();
  });
  document.addEventListener('shopify:block:select', (event) => {
    if (event.target.matches('details')) event.target.open = true;
  });
})();
